import { render, staticRenderFns } from "./iata.vue?vue&type=template&id=e2811ef4&scoped=true&"
import script from "./iata.vue?vue&type=script&lang=js&"
export * from "./iata.vue?vue&type=script&lang=js&"
import style0 from "./iata.vue?vue&type=style&index=0&id=e2811ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2811ef4",
  null
  
)

export default component.exports